

// import React, { useEffect, useState } from "react";
// import { getMyNews, deleteNews } from "../../../services/reporterService";
// import {
//   CircularProgress,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Pagination,
//   Stack,
//   Select,
//   MenuItem,
// } from "@mui/material";

// import {


 

//   Box,
//   Grid,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon
// } from "@mui/material";
// import { Chip, Divider, Card, CardContent } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// const MyNews = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // modal state
//   const [open, setOpen] = useState(false);
//   const [selectedNews, setSelectedNews] = useState(null);

//   // delete confirm modal
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
//   const [deleting, setDeleting] = useState(false);

//   // pagination state
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   // fetch news
//   const fetchMyNews = async (pageNumber = page) => {
//     try {
//       setLoading(true);
//       const response = await getMyNews({ page: pageNumber, limit });
//       setNews(response.data || []);
//       setTotalPages(response.totalPages || 1);
//       setPage(pageNumber);
//     } catch (error) {
//       console.error("Failed to load my news:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMyNews();
//   }, [limit]);

//   const handleOpen = (item) => {
//     setSelectedNews(item);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedNews(null);
//   };

//   const handleDeleteClick = (item) => {
//     setSelectedNews(item);
//     setDeleteConfirmOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!selectedNews) return;
//     try {
//       setDeleting(true);
//       await deleteNews(selectedNews._id);
//       setDeleteConfirmOpen(false);
//       setOpen(false);
//       fetchMyNews(page); // refresh current page
//     } catch (error) {
//       console.error("Failed to delete news:", error);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleDeleteCancel = () => {
//     setDeleteConfirmOpen(false);
//     setSelectedNews(null);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center mt-10">
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div className="p-4">
//       <Typography variant="h5" gutterBottom>
//         My News
//       </Typography>

//       {news.length === 0 ? (
//         <Typography>No news found.</Typography>
//       ) : (
//         <>
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead>
//                 <TableRow>
                
//                   <TableCell></TableCell>
//                   <TableCell>Title</TableCell>
//                   <TableCell>Category</TableCell>
//                   <TableCell>Sub Category</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell>Created At</TableCell>
//                   <TableCell align="center">Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {news.map((item) => (
//                   <TableRow key={item._id}>
//                <TableCell>
//   {item.media && item.media.length > 0 ? (
//     <img
//       src={item.media[0].url}
//       alt={item.media[0].caption || "News image"}
//       style={{
//         width: "70px",
//         maxHeight: "70px",
//         objectFit: "contain",
//         borderRadius: "8px",
//         marginBottom: "16px",
//         backgroundColor: "#f0fdf9ff",
//       }}
//     />
//   ) : (
//     <Typography variant="caption" color="textSecondary">
//       No Image
//     </Typography>
//   )}
// </TableCell>

                    
//                     <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
//                     <TableCell>{item.category?.name || "-"}</TableCell>
//                     <TableCell>{item.subCategory?.name || "-"}</TableCell>
//                     <TableCell>{item.status}</TableCell>
//                     <TableCell>
//                       {item.createdAtDate} {item.createdAtTime}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         onClick={() => handleOpen(item)}
//                         sx={{ mr: 1 }}
//                       >
//                         View
//                       </Button>
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         color="error"
//                         onClick={() => handleDeleteClick(item)}
//                       >
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           {/* Pagination Controls */}
//           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
//             <Pagination
//               count={totalPages}
//               page={page}
//               onChange={(e, value) => fetchMyNews(value)}
//               color="primary"
//             />
//             <Select
//               value={limit}
//               onChange={(e) => {
//                 setLimit(e.target.value);
//                 fetchMyNews(1);
//               }}
//             >
//               {[5, 10, 20, 50].map((l) => (
//                 <MenuItem key={l} value={l}>
//                   {l} per page
//                 </MenuItem>
//               ))}
//             </Select>
//           </Stack>
//         </>
//       )}

//       {/* Popup Modal for Details */}
//       {/* <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
//         <DialogTitle>{selectedNews?.title}</DialogTitle>
//         <DialogContent dividers>
//           {selectedNews?.media && selectedNews?.media.length > 0 && (
//             <img
//               src={selectedNews.media[0].url}
//               alt={selectedNews.media[0].caption || "News image"}
//               style={{
//                 width: "100%",
//                 maxHeight: "300px",
//                 objectFit: "contain",
//                 borderRadius: "8px",
//                 marginBottom: "16px",
//                 backgroundColor: "#f0fdf9ff",
//               }}
//             />
//           )}

//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Category:</strong> {selectedNews?.category?.name || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Status:</strong> {selectedNews?.status}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Country:</strong> {selectedNews?.country?.name || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>State:</strong> {selectedNews?.state?.name || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>City:</strong> {selectedNews?.city?.name || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
//           </Typography>
//           <Typography variant="subtitle1" gutterBottom>
//             <strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / (
//             {selectedNews?.createdBy?.email})
//           </Typography>
//           <Typography variant="subtitle2" gutterBottom>
//             <strong>Posted Date:</strong> {selectedNews?.postedDate}{" "}
//             {selectedNews?.postedTime}
//           </Typography>
//           <Typography variant="subtitle2" gutterBottom>
//             <strong>Last Updated:</strong> {selectedNews?.updatedAtDate}{" "}
//             {selectedNews?.updatedAtTime}
//           </Typography>
//           <Typography variant="body1" sx={{ mt: 2, whiteSpace: "pre-line" }}>
//             <strong>Content:</strong>
//             <br />
//             {selectedNews?.content || "No content available"}
//           </Typography>
//           {selectedNews?.tags?.length > 0 && (
//             <Typography variant="subtitle1" sx={{ mt: 2 }}>
//               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
//             </Typography>
//           )}
//           <Typography variant="subtitle2" sx={{ mt: 2 }}>
//             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
//           </Typography>
//           <Typography variant="subtitle2">
//             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
//           </Typography>
//           <Typography variant="subtitle2">
//             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose} variant="contained" color="primary">
//             Close
//           </Button>
//           <Button
//             onClick={() => handleDeleteClick(selectedNews)}
//             variant="contained"
//             color="error"
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog> */}
// <Dialog
//   open={open}
//   onClose={handleClose}
//   fullWidth
//   maxWidth="lg"
//   scroll="paper"
// >
//   <DialogTitle>News Details</DialogTitle>

//   <DialogContent
//     dividers
//     sx={{
//       maxHeight: "70vh",
//       overflowY: "auto",
//     }}
//   >

//     {/* Image */}
//     {selectedNews?.media?.length > 0 && (
//       <Box sx={{ mb: 2 }}>
//         <img
//           src={selectedNews.media[0].url}
//           alt={selectedNews.media[0].caption || "News image"}
//           style={{
//             width: "100%",
//             maxHeight: "300px",
//             objectFit: "contain",
//             borderRadius: "8px",
//             background: "#f5f5f5"
//           }}
//         />
//       </Box>
//     )}

//     <Grid container spacing={2}>

//       <Grid item xs={12}>
//         <Typography variant="h6">
//           <strong>Title (English): </strong>
//           {selectedNews?.title_en || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography variant="h6">
//           <strong>शीर्षक (हिंदी): </strong>
//           <span
//             dangerouslySetInnerHTML={{
//               __html: selectedNews?.title_hi || "-"
//             }}
//           />
//         </Typography>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography>
//           <strong>Summary (English): </strong>
//           {selectedNews?.summary_en || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography>
//           <strong>सारांश (हिंदी): </strong>
//           {selectedNews?.summary_hi || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={6}>
//         <Typography>
//           <strong>Category:</strong> {selectedNews?.category?.name || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={6}>
//         <Typography>
//           <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
//         </Typography>
//       </Grid>

//       {selectedNews?.subSubCategory && (
//         <Grid item xs={6}>
//           <Typography>
//             <strong>Sub-Sub Category:</strong> {selectedNews.subSubCategory}
//           </Typography>
//         </Grid>
//       )}

//       <Grid item xs={6}>
//         <Typography>
//           <strong>Status:</strong> {selectedNews?.status}
//         </Typography>
//       </Grid>

//       <Grid item xs={4}>
//         <Typography>
//           <strong>Country:</strong> {selectedNews?.country?.name || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={4}>
//         <Typography>
//           <strong>State:</strong> {selectedNews?.state?.name || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={4}>
//         <Typography>
//           <strong>City:</strong> {selectedNews?.city?.name || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography>
//           <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
//         </Typography>
//       </Grid>

//       <Grid item xs={12}>
//         <Typography>
//           <strong>Reporter:</strong>{" "}
//           {selectedNews?.createdBy?.name || "-"} ({selectedNews?.createdBy?.email})
//         </Typography>
//       </Grid>

//       <Grid item xs={6}>
//         <Typography>
//           <strong>Posted Date:</strong>{" "}
//           {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || ""}
//         </Typography>
//       </Grid>

//       <Grid item xs={6}>
//         <Typography>
//           <strong>Last Updated:</strong>{" "}
//           {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}
//         </Typography>
//       </Grid>

//     </Grid>


//     {/* Content English */}
//     <Box sx={{ mt: 3 }}>
//       <Typography variant="h6">
//         <strong>Content (English)</strong>
//       </Typography>

//       <Box
//         dangerouslySetInnerHTML={{
//           __html: selectedNews?.content_en || "No English content available"
//         }}
//       />
//     </Box>


//     {/* Content Hindi */}
//     <Box sx={{ mt: 3 }}>
//       <Typography variant="h6">
//         <strong>सामग्री (हिंदी)</strong>
//       </Typography>

//       <Box
//         dangerouslySetInnerHTML={{
//           __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है"
//         }}
//       />
//     </Box>


//     {/* Tags */}
//     {selectedNews?.tags?.length > 0 && (
//       <Box sx={{ mt: 2 }}>
//         <Typography>
//           <strong>Tags:</strong> {selectedNews.tags.join(", ")}
//         </Typography>
//       </Box>
//     )}


//     {/* Reference Links */}
//     {selectedNews?.referenceLinks?.length > 0 && (
//       <Box sx={{ mt: 3 }}>
//         <Typography variant="h6">Reference Links</Typography>

//         <List dense>
//           {selectedNews.referenceLinks.map((link, index) => (
//             <ListItem key={index}>
//               <ListItemText
//                 primary={
//                   <a
//                     href={link}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ wordBreak: "break-all" }}
//                   >
//                     {link}
//                   </a>
//                 }
//               />
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     )}


//     {/* PDF Files */}
//     {selectedNews?.pdfFiles?.length > 0 && (
//       <Box sx={{ mt: 3 }}>
//         <Typography variant="h6">PDF Files</Typography>

//         <List dense>
//           {selectedNews.pdfFiles.map((pdf, index) => (
//             <ListItem key={pdf._id || index}>
//               <ListItemIcon>
//                 <PictureAsPdfIcon />
//               </ListItemIcon>

//               <ListItemText
//                 primary={
//                   <a
//                     href={pdf.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ wordBreak: "break-all" }}
//                   >
//                     {pdf.originalName || pdf.url.split("/").pop()}
//                   </a>
//                 }
//               />
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     )}


//     {/* Stats */}
//     <Box sx={{ mt: 3 }}>
//       <Typography>
//         <strong>Views:</strong> {selectedNews?.viewsCount || 0}
//       </Typography>

//       <Typography>
//         <strong>Likes:</strong> {selectedNews?.likesCount || 0}
//       </Typography>

//       <Typography>
//         <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
//       </Typography>
//     </Box>

//   </DialogContent>

//   <DialogActions>
//     <Button onClick={handleClose} variant="contained">
//       Close
//     </Button>

//     <Button
//       onClick={() => handleDeleteClick(selectedNews)}
//       variant="contained"
//       color="error"
//     >
//       Delete
//     </Button>
//   </DialogActions>

// </Dialog>
       

//       {/* Delete Confirm Modal */}
//       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent dividers>
//           Are you sure you want to delete this news?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCancel} disabled={deleting}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDeleteConfirm}
//             color="error"
//             variant="contained"
//             disabled={deleting}
//           >
//             {deleting ? "Deleting..." : "Delete"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default MyNews;




import React, { useEffect, useState, useRef, useCallback } from "react";
import { getMyNews, deleteNews,updateNews ,uploadMediaFiles} from "../../../services/reporterService";
import {
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  Stack,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  Box,
  IconButton,
  ListItem,
  List,
  ListItemText,
  Alert,
  Divider,
  ListItemIcon,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
  getCategories,
  getSubcategories,
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';
import LinkIcon from '@mui/icons-material/Link';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// ─────────────────────────────────────────────
// TinyMCE CDN Wrapper — No API Key Needed
// ─────────────────────────────────────────────
const TinyEditor = ({ value, onEditorChange, editorRef, config, id }) => {
  const containerRef = useRef(null);
  const editorInstanceRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    const initEditor = () => {
      if (!window.tinymce || !containerRef.current || isInitialized.current) return;
      isInitialized.current = true;

      const textarea = containerRef.current.querySelector('textarea');
      if (!textarea) return;

      window.tinymce.init({
        target: textarea,
        ...config,
        setup: (editor) => {
          editorInstanceRef.current = editor;
          if (editorRef) editorRef.current = editor;
          if (config.setup) config.setup(editor);
          editor.on('init', () => {
            if (value) editor.setContent(value);
          });
          editor.on('input change keyup', () => {
            if (onEditorChange) onEditorChange(editor.getContent());
          });
        },
      });
    };

    if (window.tinymce) {
      initEditor();
    } else {
      const existing = document.getElementById('tinymce-cdn-script');
      if (!existing) {
        const script = document.createElement('script');
        script.id = 'tinymce-cdn-script';
        script.src = 'https://cdn.jsdelivr.net/npm/tinymce@6/tinymce.min.js';
        script.referrerPolicy = 'origin';
        script.onload = () => setTimeout(initEditor, 100);
        document.head.appendChild(script);
      } else {
        existing.addEventListener('load', () => setTimeout(initEditor, 100));
      }
    }

    return () => {
      if (editorInstanceRef.current) {
        try { editorInstanceRef.current.remove(); } catch (e) {}
        editorInstanceRef.current = null;
        isInitialized.current = false;
      }
    };
  }, []);

  // Sync value from outside only when it's cleared (reset)
  useEffect(() => {
    if (editorInstanceRef.current && value === '') {
      editorInstanceRef.current.setContent('');
    }
  }, [value]);

  // Sync value when dialog opens with new content
  useEffect(() => {
    if (editorInstanceRef.current && value !== undefined) {
      const currentContent = editorInstanceRef.current.getContent();
      if (currentContent !== value) {
        editorInstanceRef.current.setContent(value || '');
      }
    }
  }, [value]);

  return (
    <div ref={containerRef}>
      <textarea id={id} defaultValue={value} style={{ visibility: 'hidden', height: 0 }} />
    </div>
  );
};

// ─────────────────────────────────────────────

const RASHI_OPTIONS = [
  "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
  "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
];

const isValidUrl = (string) => {
  try { new URL(string); return true; } catch (e) { return false; }
};

const MyNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [newMediaFiles, setNewMediaFiles] = useState([]);
  const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
  const [mediaUrlInput, setMediaUrlInput] = useState('');

  const [existingPdfFiles, setExistingPdfFiles] = useState([]);
  const [newPdfFiles, setNewPdfFiles] = useState([]);
  const [pdfUrlInput, setPdfUrlInput] = useState('');

  const [formErrors, setFormErrors] = useState({});

  const [categoriesDropdown, setCategoriesDropdown] = useState([]);
  const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
  const [countriesDropdown, setCountriesDropdown] = useState([]);
  const [statesDropdown, setStatesDropdown] = useState([]);
  const [citiesDropdown, setCitiesDropdown] = useState([]);

  const [updateError, setUpdateError] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [updating, setUpdating] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const editorRefEn = useRef(null);
  const editorRefHi = useRef(null);
  const editorRefTitleEn = useRef(null);
  const editorRefTitleHi = useRef(null);

  // Track uploaded URLs from editor (avoid closure issues)
  const existingMediaRef = useRef([]);
  useEffect(() => { existingMediaRef.current = existingMediaToKeep; }, [existingMediaToKeep]);

  const extractUrlsFromHtml = useCallback((htmlContent) => {
    const extracted = new Set();
    if (!htmlContent) return Array.from(extracted);
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    doc.querySelectorAll('img, video, source, iframe, a').forEach(el => {
      let url = el.getAttribute('src') || el.getAttribute('href');
      if (url && isValidUrl(url)) extracted.add(url);
    });
    doc.querySelectorAll('img').forEach(el => {
      const srcset = el.getAttribute('srcset');
      if (srcset) {
        srcset.split(',').forEach(srcPart => {
          const url = srcPart.trim().split(' ')[0];
          if (url && isValidUrl(url)) extracted.add(url);
        });
      }
    });
    doc.querySelectorAll('[data-mce-src]').forEach(el => {
      const v = el.getAttribute('data-mce-src');
      if (v && isValidUrl(v)) extracted.add(v);
    });
    doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
      const v = el.getAttribute('data-mce-p-src');
      if (v && isValidUrl(v)) extracted.add(v);
    });
    return Array.from(extracted);
  }, []);

  const fetchMyNews = useCallback(async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await getMyNews({ page: pageNumber, limit });
      setNews(response.data || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      console.error("ERROR: Failed to load my news:", error);
    } finally {
      setLoading(false);
    }
  }, [limit, page]);

  // ─────────────────────────────────────────────
  // TinyMCE Config — Headline (minimal)
  // ─────────────────────────────────────────────
  const headlineEditorConfig = {
    height: 180,
    menubar: false,
    branding: false,
    license_key: 'gpl',
    plugins: ['lists', 'link', 'searchreplace', 'wordcount'],
    toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    forced_root_block: 'p',
    paste_as_text: true,
    invalid_styles: 'font-size font-family',
    content_style: `body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }`,
  };

  // ─────────────────────────────────────────────
  // TinyMCE Config — Full Content Editor
  // ─────────────────────────────────────────────
  const buildEditorConfig = useCallback(() => ({
    height: 500,
    menubar: true,
    branding: false,
    license_key: 'gpl',
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
      'codesample', 'hr', 'nonbreaking', 'directionality', 'quickbars'
    ],
    toolbar1: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify',
    toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview',
    toolbar3: 'insertfile image media link anchor codesample | customupload | ltr rtl',
    content_style: `
      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; font-size: 14px; line-height: 1.6; margin: 1rem; }
      img { max-width: 100%; height: auto; }
    `,
    paste_data_images: true,
    automatic_uploads: true,
    file_picker_types: 'image media',
    file_picker_callback: function (callback, value, meta) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      if (meta.filetype === 'image') input.setAttribute('accept', 'image/*');
      else if (meta.filetype === 'media') input.setAttribute('accept', 'video/*,audio/*');
      else input.setAttribute('accept', 'image/*,video/*,audio/*');

      input.onchange = function () {
        const file = this.files[0];
        if (!file) return;
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...existingMediaRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                existingMediaRef.current = currentUrls;
                setExistingMediaToKeep(currentUrls);
              }
              callback(uploadedUrl, { title: file.name, alt: file.name });
              editor.notificationManager.open({ text: `File "${file.name}" uploaded!`, type: 'success', timeout: 3000 });
            } else throw new Error('No URL returned');
          })
          .catch(err => {
            editor.setProgressState(false);
            editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 });
          });
      };
      input.click();
    },
    images_upload_handler: function (blobInfo) {
      return new Promise((resolve, reject) => {
        const blob = blobInfo.blob();
        const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, { type: blob.type || 'image/png' });
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...existingMediaRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                existingMediaRef.current = currentUrls;
                setExistingMediaToKeep(currentUrls);
              }
              resolve(uploadedUrl);
            } else reject(new Error('No URL returned'));
          })
          .catch(err => { editor.setProgressState(false); reject(err); });
      });
    },
    setup: function (editor) {
      editor.ui.registry.addButton('customupload', {
        text: 'Upload Media',
        icon: 'upload',
        tooltip: 'Upload images or videos',
        onAction: function () {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*,video/*,application/pdf');
          input.setAttribute('multiple', 'true');
          input.onchange = function () {
            const files = Array.from(this.files);
            if (!files.length) return;
            editor.setProgressState(true);
            const fd = new FormData();
            files.forEach(f => fd.append('mediaFiles', f));
            uploadMediaFiles(fd)
              .then(response => {
                editor.setProgressState(false);
                if (response && response.locations && response.locations.length > 0) {
                  const currentUrls = [...existingMediaRef.current];
                  const newUrls = response.locations.filter(u => !currentUrls.includes(u));
                  const updatedUrls = [...currentUrls, ...newUrls];
                  existingMediaRef.current = updatedUrls;
                  setExistingMediaToKeep(updatedUrls);

                  response.locations.forEach((url, i) => {
                    const f = files[i];
                    if (f && f.type.startsWith('image/')) {
                      editor.insertContent(`<img src="${url}" alt="${f.name}" style="max-width: 100%; height: auto;" />`);
                    } else if (f && f.type.startsWith('video/')) {
                      editor.insertContent(`<video controls style="max-width: 100%; height: auto;"><source src="${url}" type="${f.type}">Your browser does not support the video tag.</video>`);
                    } else if (f && f.type === 'application/pdf') {
                      setExistingPdfFiles(prev => [...prev, { url, originalName: f.name }]);
                      editor.insertContent(`<p><a href="${url}" target="_blank">${f.name}</a></p>`);
                    }
                  });
                  editor.notificationManager.open({ text: `Uploaded ${response.locations.length} file(s)!`, type: 'success', timeout: 3000 });
                }
              })
              .catch(err => { editor.setProgressState(false); editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 }); });
          };
          input.click();
        }
      });
    },
    contextmenu: 'link image table',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_insert_toolbar: 'quickimage quicktable customupload',
    image_advtab: true,
    image_uploadtab: true,
    image_caption: true,
    image_title: true,
    formats: {
      bold: { inline: 'strong' },
      italic: { inline: 'em' },
      underline: { inline: 'u' },
      strikethrough: { inline: 'del' },
    }
  }), []);

  const editorConfig = buildEditorConfig();

  useEffect(() => {
    const fetchInitialDropdownData = async () => {
      try {
        const [catsRes, countriesRes] = await Promise.all([getCategories(), getCountries()]);
        setCategoriesDropdown(catsRes.data || []);
        setCountriesDropdown(countriesRes.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load initial dropdown data:", err);
      }
    };
    fetchInitialDropdownData();
    fetchMyNews();
  }, [limit, fetchMyNews]);

  const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
    if (categoryId) {
      try { const res = await getSubcategories(categoryId); setSubCategoriesDropdown(res.data || []); }
      catch (err) { setSubCategoriesDropdown([]); }
    } else { setSubCategoriesDropdown([]); }
  }, []);

  const fetchStatesForEdit = useCallback(async (countryId) => {
    if (countryId) {
      try { const res = await getStatesByCountry(countryId); setStatesDropdown(res.data || []); }
      catch (err) { setStatesDropdown([]); }
    } else { setStatesDropdown([]); }
  }, []);

  const fetchCitiesForEdit = useCallback(async (stateId) => {
    if (stateId) {
      try { const res = await getCitiesByState(stateId); setCitiesDropdown(res.data || []); }
      catch (err) { setCitiesDropdown([]); }
    } else { setCitiesDropdown([]); }
  }, []);

  const handleViewOpen = (item) => { setSelectedNews(item); setViewOpen(true); };
  const handleViewClose = () => { setViewOpen(false); setSelectedNews(null); };

  const handleEditOpen = async (item) => {
    setSelectedNews(item);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    await fetchSubcategoriesForEdit(item.category?._id);
    await fetchStatesForEdit(item.country?._id);
    await fetchCitiesForEdit(item.state?._id);

    setEditFormData({
      title_en: item.title_en || '',
      title_hi: item.title_hi || '',
      content_en: item.content_en || '',
      content_hi: item.content_hi || '',
      summary_en: item.summary_en || '',
      summary_hi: item.summary_hi || '',
      category: item.category?._id || '',
      subCategory: item.subCategory?._id || '',
      tags: item.tags || [],
      country: item.country?._id || '',
      state: item.state?._id || '',
      city: item.city?._id || '',
      localAddress: item.localAddress || '',
      subSubCategory: item.subSubCategory || '',
    });

    let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);
    if (item.mediaUrls && Array.isArray(item.mediaUrls)) item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
    extractUrlsFromHtml(item.content_en).forEach(url => initialMediaUrlsToKeep.add(url));
    extractUrlsFromHtml(item.content_hi).forEach(url => initialMediaUrlsToKeep.add(url));

    const initialArray = Array.from(initialMediaUrlsToKeep);
    setExistingMediaToKeep(initialArray);
    existingMediaRef.current = initialArray;

    setExistingPdfFiles(item.pdfFiles || []);
    setNewPdfFiles([]);
    setPdfUrlInput('');
    setNewMediaFiles([]);
    setMediaUrlInput('');
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedNews(null);
    setEditFormData({});
    setNewMediaFiles([]);
    setExistingMediaToKeep([]);
    existingMediaRef.current = [];
    setSubCategoriesDropdown([]);
    setStatesDropdown([]);
    setCitiesDropdown([]);
    setUpdateError(null);
    setUpdateSuccess(null);
    setMediaUrlInput('');
    setFormErrors({});
    setExistingPdfFiles([]);
    setNewPdfFiles([]);
    setPdfUrlInput('');
  };

  const handleEditFormChange = async (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: '' }));
    if (name === 'category') { setEditFormData(prev => ({ ...prev, subCategory: '', subSubCategory: '' })); await fetchSubcategoriesForEdit(value); }
    else if (name === 'country') { setEditFormData(prev => ({ ...prev, state: '', city: '' })); await fetchStatesForEdit(value); }
    else if (name === 'state') { setEditFormData(prev => ({ ...prev, city: '' })); await fetchCitiesForEdit(value); }
  };

  const handleEditEditorChange = (content, editorName) => {
    setEditFormData(prev => ({ ...prev, [editorName]: content }));
    setFormErrors(prev => ({ ...prev, [editorName]: '' }));
    const extractedUrls = extractUrlsFromHtml(content);
    setExistingMediaToKeep(prev => {
      const combined = new Set([...prev, ...extractedUrls]);
      const arr = Array.from(combined);
      existingMediaRef.current = arr;
      return arr;
    });
  };

  const handleTagsChange = (e) => {
    const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
    setEditFormData(prev => ({ ...prev, tags: tagsArray }));
  };

  const handleNewMediaUpload = (e) => setNewMediaFiles(Array.from(e.target.files));
  const handleRemoveExistingMedia = (urlToRemove) => setExistingMediaToKeep(prev => prev.filter(url => url !== urlToRemove));

  const handleMediaUrlInputChange = (e) => { setMediaUrlInput(e.target.value); setFormErrors(prev => ({ ...prev, mediaUrlInput: '' })); };
  const handleAddMediaUrl = () => {
    const url = mediaUrlInput.trim();
    if (!url) return;
    if (!isValidUrl(url)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' })); return; }
    if (!existingMediaToKeep.includes(url)) { setExistingMediaToKeep(prev => [...prev, url]); setMediaUrlInput(''); }
    else setFormErrors(prev => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
  };

  const handleNewPdfUpload = (e) => setNewPdfFiles(Array.from(e.target.files));
  const handleRemoveExistingPdf = (pdfToRemove) => setExistingPdfFiles(prev => prev.filter(pdf => (pdf._id || pdf.url) !== (pdfToRemove._id || pdfToRemove.url)));
  const handlePdfUrlInputChange = (e) => { setPdfUrlInput(e.target.value); setFormErrors(prev => ({ ...prev, pdfUrlInput: '' })); };
  const handleAddPdfUrl = () => {
    const url = pdfUrlInput.trim();
    if (!url) return;
    if (!isValidUrl(url)) { setFormErrors(prev => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' })); return; }
    if (!existingPdfFiles.some(pdf => pdf.url === url)) { setExistingPdfFiles(prev => [...prev, { url, originalName: url.split('/').pop() || 'external_pdf' }]); setPdfUrlInput(''); }
    else setFormErrors(prev => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
  };

  const handleUpdateSubmit = async () => {
    if (!selectedNews) return;
    setUpdating(true);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    // Get fresh content from editors before submit
    const title_en_final = editorRefTitleEn.current ? editorRefTitleEn.current.getContent() : editFormData.title_en;
    const title_hi_final = editorRefTitleHi.current ? editorRefTitleHi.current.getContent() : editFormData.title_hi;
    const content_en_final = editorRefEn.current ? editorRefEn.current.getContent() : editFormData.content_en;
    const content_hi_final = editorRefHi.current ? editorRefHi.current.getContent() : editFormData.content_hi;

    let currentMediaUrls = [...existingMediaToKeep];
    const currentMediaUrlInputVal = mediaUrlInput.trim();
    if (currentMediaUrlInputVal) {
      if (!isValidUrl(currentMediaUrlInputVal)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
      if (!currentMediaUrls.includes(currentMediaUrlInputVal)) currentMediaUrls.push(currentMediaUrlInputVal);
      else { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'This URL has already been added.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
    }

    try {
      let finalMediaUrls = [...currentMediaUrls];
      let finalPdfFiles = [...existingPdfFiles];

      if (newMediaFiles.length > 0) {
        const fd = new FormData();
        newMediaFiles.forEach(file => fd.append('mediaFiles', file));
        const uploadResponse = await uploadMediaFiles(fd);
        if (uploadResponse && uploadResponse.locations) {
          finalMediaUrls = [...finalMediaUrls, ...uploadResponse.locations.filter(url => !finalMediaUrls.includes(url))];
        } else throw new Error('Failed to upload new media files.');
      }

      if (newPdfFiles.length > 0) {
        const fd = new FormData();
        newPdfFiles.forEach(file => fd.append('mediaFiles', file));
        const uploadResponsePdfs = await uploadMediaFiles(fd);
        if (uploadResponsePdfs && uploadResponsePdfs.locations) {
          uploadResponsePdfs.locations.forEach((url, index) => {
            finalPdfFiles.push({ url, originalName: newPdfFiles[index].name });
          });
        } else throw new Error('Failed to upload new PDF files.');
      }

      const currentPdfUrlInputVal = pdfUrlInput.trim();
      if (currentPdfUrlInputVal) {
        if (!isValidUrl(currentPdfUrlInputVal)) { setFormErrors(prev => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
        if (!finalPdfFiles.some(pdf => pdf.url === currentPdfUrlInputVal)) {
          finalPdfFiles.push({ url: currentPdfUrlInputVal, originalName: currentPdfUrlInputVal.split('/').pop() || 'external_pdf' });
        }
      }

      const formDataPayload = new FormData();
      const updatedFormData = { ...editFormData, title_en: title_en_final, title_hi: title_hi_final, content_en: content_en_final, content_hi: content_hi_final };

      Object.keys(updatedFormData).forEach(key => {
        if (key === 'tags') formDataPayload.append(key, JSON.stringify(updatedFormData[key]));
        else if (updatedFormData[key] !== undefined && updatedFormData[key] !== null) formDataPayload.append(key, updatedFormData[key]);
        else formDataPayload.append(key, '');
      });

      formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));
      formDataPayload.append('pdfFiles', JSON.stringify(finalPdfFiles));

      const response = await updateNews(selectedNews._id, formDataPayload);
      setUpdateSuccess(response.message || "News updated successfully!");
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to update news:", error);
      setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
    } finally {
      setUpdating(false);
    }
  };

  const handleDeleteClick = (item) => { setSelectedNews(item); setDeleteConfirmOpen(true); };
  const handleDeleteConfirm = async () => {
    if (!selectedNews) return;
    try {
      setDeleting(true);
      await deleteNews(selectedNews._id);
      setDeleteConfirmOpen(false);
      setViewOpen(false);
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to delete news:", error);
    } finally { setDeleting(false); }
  };
  const handleDeleteCancel = () => { setDeleteConfirmOpen(false); setSelectedNews(null); };

  const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
  const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
  const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

  if (loading) {
    return <div className="flex justify-center items-center mt-10"><CircularProgress /></div>;
  }

  return (
    <div className="p-4">
      <Typography variant="h5" gutterBottom>My News</Typography>

      {news.length === 0 ? (
        <Typography>No news found.</Typography>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#No</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {news.map((item, index) => (
                  <TableRow key={item._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {item.media && item.media.length > 0 ? (
                        item.media[0].type === "video" ? (
                          <video src={item.media[0].url} width="90" height="60" controls={false} autoPlay muted loop style={{ borderRadius: "8px", objectFit: "cover", backgroundColor: "#f0fdf9ff" }} />
                        ) : (
                          <img src={item.media[0].url} alt={item.media[0].caption || "News image"} style={{ width: "90px", maxHeight: "70px", objectFit: "contain", borderRadius: "8px", backgroundColor: "#f0fdf9ff" }} />
                        )
                      ) : (
                        <Typography variant="caption" color="textSecondary">No Media</Typography>
                      )}
                    </TableCell>
                    <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
                    <TableCell>{item.category?.name || "-"}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{item.createdAtDate} {item.createdAtTime}</TableCell>
                    <TableCell align="center">
                      <Button size="small" variant="outlined" onClick={() => handleViewOpen(item)} sx={{ mr: 1 }}>View</Button>
                      <Button size="small" variant="outlined" color="primary" onClick={() => handleEditOpen(item)} sx={{ mr: 1 }}>Edit</Button>
                      {/* <Button size="small" variant="outlined" color="error" onClick={() => handleDeleteClick(item)}>Delete</Button> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
            <Pagination count={totalPages} page={page} onChange={(e, value) => setPage(value)} color="primary" />
            <Select value={limit} onChange={(e) => { setLimit(e.target.value); fetchMyNews(1); }}>
              {[5, 10, 20, 50].map(l => <MenuItem key={l} value={l}>{l} per page</MenuItem>)}
            </Select>
          </Stack>
        </>
      )}

      {/* ── View Dialog ── */}
      <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
        <DialogTitle>News Details</DialogTitle>
        <DialogContent dividers>
          {selectedNews?.media && selectedNews?.media.length > 0 && (
            <img src={selectedNews.media[0].url} alt={selectedNews.media[0].caption || "News image"} style={{ width: "100%", maxHeight: "300px", objectFit: "contain", borderRadius: "8px", marginBottom: "16px", backgroundColor: "#f0fdf9ff" }} />
          )}
          <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
          <Typography variant="h6" gutterBottom>
            <strong>शीर्षक (हिंदी): </strong>
            <span dangerouslySetInnerHTML={{ __html: selectedNews?.title_hi || "-" }} />
          </Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
          {selectedNews?.subSubCategory && <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>}
          <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>
          <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
          <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Content (English):</strong><br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>सामग्री (हिंदी):</strong><br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
          </Typography>
          {selectedNews?.tags?.length > 0 && <Typography variant="subtitle1" sx={{ mt: 2 }}><strong>Tags:</strong> {selectedNews.tags.join(", ")}</Typography>}
          {selectedNews?.referenceLinks?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
              <List dense>
                {selectedNews.referenceLinks.map((link, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          {selectedNews?.pdfFiles?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>PDF Files:</strong></Typography>
              <List dense>
                {selectedNews.pdfFiles.map((pdf, index) => (
                  <ListItem key={pdf._id || index} disablePadding>
                    <ListItemIcon><PictureAsPdfIcon /></ListItemIcon>
                    <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          <Typography variant="subtitle2" sx={{ mt: 2 }}><strong>Views:</strong> {selectedNews?.viewsCount || 0}</Typography>
          <Typography variant="subtitle2"><strong>Likes:</strong> {selectedNews?.likesCount || 0}</Typography>
          <Typography variant="subtitle2"><strong>Comments:</strong> {selectedNews?.commentsCount || 0}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewClose} variant="contained" color="primary">Close</Button>
          <Button onClick={() => handleDeleteClick(selectedNews)} variant="contained" color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* ── Edit Dialog ── */}
      <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md" disableEnforceFocus={true}>
        <DialogTitle>
          Edit News:{" "}
          <span dangerouslySetInnerHTML={{ __html: selectedNews?.title_en || selectedNews?.title_hi || "-" }} />
        </DialogTitle>
        <DialogContent dividers>
          {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
          {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}

          {/* Title English */}
          <Typography variant="body2" color="textSecondary" gutterBottom>Title (English) *</Typography>
          <Box sx={{ border: formErrors.title_en ? "1px solid red" : "1px solid #ccc", borderRadius: 1, mb: 1 }}>
            <TinyEditor
              id="edit_title_en_editor"
              value={editFormData.title_en || ''}
              onEditorChange={(content) => setEditFormData(prev => ({ ...prev, title_en: content }))}
              editorRef={editorRefTitleEn}
              config={headlineEditorConfig}
            />
          </Box>
          {formErrors.title_en && <Typography color="error" variant="caption">{formErrors.title_en}</Typography>}

          {/* Title Hindi */}
          <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 2 }}>शीर्षक (हिंदी) *</Typography>
          <Box sx={{ border: formErrors.title_hi ? "1px solid red" : "1px solid #ccc", borderRadius: 1, mb: 1 }}>
            <TinyEditor
              id="edit_title_hi_editor"
              value={editFormData.title_hi || ''}
              onEditorChange={(content) => setEditFormData(prev => ({ ...prev, title_hi: content }))}
              editorRef={editorRefTitleHi}
              config={headlineEditorConfig}
            />
          </Box>
          {formErrors.title_hi && <Typography color="error" variant="caption">{formErrors.title_hi}</Typography>}

          <TextField margin="dense" name="summary_en" label="Summary (English)" fullWidth multiline rows={2} variant="outlined" value={editFormData.summary_en || ""} onChange={handleEditFormChange} sx={{ mb: 2, mt: 2 }} error={!!formErrors.summary_en} helperText={formErrors.summary_en} />
          <TextField margin="dense" name="summary_hi" label="सारांश (हिंदी)" fullWidth multiline rows={2} variant="outlined" value={editFormData.summary_hi || ""} onChange={handleEditFormChange} sx={{ mb: 2 }} error={!!formErrors.summary_hi} helperText={formErrors.summary_hi} />

          {/* Content English */}
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>Content (English) *</Typography>
            <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <TinyEditor
                id="edit_content_en_editor"
                value={editFormData.content_en || ''}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
                editorRef={editorRefEn}
                config={editorConfig}
              />
            </Box>
            {formErrors.content_en && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_en}</Typography>}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* Content Hindi */}
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>सामग्री (हिंदी) *</Typography>
            <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <TinyEditor
                id="edit_content_hi_editor"
                value={editFormData.content_hi || ''}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
                editorRef={editorRefHi}
                config={editorConfig}
              />
            </Box>
            {formErrors.content_hi && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_hi}</Typography>}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* Category */}
          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="category-select-label">Category</InputLabel>
            <Select labelId="category-select-label" name="category" value={editFormData.category || ''} label="Category" onChange={handleEditFormChange} error={!!formErrors.category}>
              <MenuItem value="">Select Category</MenuItem>
              {categoriesDropdown.map(cat => <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>)}
            </Select>
            {formErrors.category && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.category}</Typography>}
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
            <Select labelId="subcategory-select-label" name="subCategory" value={editFormData.subCategory || ''} label="Sub Category" onChange={handleEditFormChange} disabled={!editFormData.category || subCategoriesDropdown.length === 0}>
              <MenuItem value="">Select Sub Category (Optional)</MenuItem>
              {subCategoriesDropdown.map(subCat => <MenuItem key={subCat._id} value={subCat._id}>{subCat.name}</MenuItem>)}
            </Select>
          </FormControl>

          {showSubSubCategoryDropdown && (
            <TextField label="Select Rashi (subSubCategory)" name="subSubCategory" select fullWidth margin="normal" value={editFormData.subSubCategory} onChange={handleEditFormChange} sx={{ mb: 2 }}>
              <MenuItem value="">Select Rashi</MenuItem>
              {RASHI_OPTIONS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
            </TextField>
          )}

          {/* <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
            <OutlinedInput id="news-tags" name="tags" value={editFormData.tags?.join(', ') || ""} onChange={handleTagsChange} label="Tags (comma separated)" />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
              {editFormData.tags?.map((tag, index) => <Chip key={index} label={tag} />)}
            </Box>
          </FormControl> */}

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="country-select-label">Country</InputLabel>
            <Select labelId="country-select-label" name="country" value={editFormData.country || ''} label="Country" onChange={handleEditFormChange}>
              <MenuItem value="">Select Country (Optional)</MenuItem>
              {countriesDropdown.map(country => <MenuItem key={country._id} value={country._id}>{country.name}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select labelId="state-select-label" name="state" value={editFormData.state || ''} label="State" onChange={handleEditFormChange} disabled={!editFormData.country || statesDropdown.length === 0}>
              <MenuItem value="">Select State (Optional)</MenuItem>
              {statesDropdown.map(state => <MenuItem key={state._id} value={state._id}>{state.name}</MenuItem>)}
            </Select>
          </FormControl>

          {/* Media Section */}
          <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>Media Files & External URLs</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>Upload new images/videos or add external media URLs.</Typography>
            <Button variant="outlined" component="label" fullWidth startIcon={<AddCircleOutlineIcon />} sx={{ mb: 2, py: 1.5 }} disabled={updating}>
              Upload Images/Videos
              <input type="file" hidden onChange={handleNewMediaUpload} multiple accept="image/*,video/*" />
            </Button>
            {newMediaFiles.length > 0 && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>New Images/Videos to Upload:</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {newMediaFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={() => setNewMediaFiles(prev => prev.filter(f => f !== file))}><CloseIcon /></IconButton>}>
                      <ListItemIcon>{file.type.startsWith('image/') ? <ImageOutlinedIcon color="primary" /> : <VideoFileIcon color="secondary" />}</ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField label="Add External Media URL" value={mediaUrlInput} onChange={handleMediaUrlInputChange} fullWidth placeholder="https://example.com/image.jpg" error={!!formErrors.mediaUrlInput} helperText={formErrors.mediaUrlInput} disabled={updating} />
              <IconButton color="primary" onClick={handleAddMediaUrl} disabled={!mediaUrlInput.trim() || updating} sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 1 }}>
                <AddCircleOutlineIcon />
              </IconButton>
            </Box>
            {existingMediaToKeep.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>Current Images/Videos ({existingMediaToKeep.length}):</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
                  {existingMediaToKeep.map((url, index) => {
                    const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
                    const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
                    return (
                      <Box key={url} sx={{ position: 'relative', width: '100px', height: '100px', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', flexDirection: 'column', padding: '5px' }}>
                        {isImage && <img src={url} alt={`Media ${index}`} style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }} />}
                        {isVideo && <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />}
                        {!isImage && !isVideo && <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />}
                        <IconButton size="small" sx={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'rgba(255,255,255,0.7)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }, zIndex: 1 }} onClick={() => handleRemoveExistingMedia(url)}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <Typography variant="caption" title={url} sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', px: 0.5, py: 0.2, fontSize: '0.6rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {url.split('/').pop().split('?')[0] || url}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* PDF Section */}
          <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>PDF Files</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>Upload new PDF files or add external PDF URLs.</Typography>
            <Button variant="outlined" component="label" fullWidth startIcon={<PictureAsPdfIcon />} sx={{ mb: 2, py: 1.5 }} disabled={updating}>
              Upload PDF Files
              <input type="file" hidden onChange={handleNewPdfUpload} multiple accept="application/pdf" />
            </Button>
            {newPdfFiles.length > 0 && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>New PDF Files to Upload:</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {newPdfFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={() => setNewPdfFiles(prev => prev.filter(f => f !== file))}><CloseIcon /></IconButton>}>
                      <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB`} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField label="Add External PDF URL" value={pdfUrlInput} onChange={handlePdfUrlInputChange} fullWidth placeholder="https://example.com/document.pdf" error={!!formErrors.pdfUrlInput} helperText={formErrors.pdfUrlInput} disabled={updating} />
              <IconButton color="primary" onClick={handleAddPdfUrl} disabled={!pdfUrlInput.trim() || updating} sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 1 }}>
                <AddCircleOutlineIcon />
              </IconButton>
            </Box>
            {existingPdfFiles.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>Current PDF Files ({existingPdfFiles.length}):</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {existingPdfFiles.map((pdf) => (
                    <ListItem key={pdf._id || pdf.url} secondaryAction={<IconButton edge="end" onClick={() => handleRemoveExistingPdf(pdf)}><CloseIcon /></IconButton>}>
                      <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                      <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="city-select-label">City</InputLabel>
            <Select labelId="city-select-label" name="city" value={editFormData.city || ''} label="City" onChange={handleEditFormChange} disabled={!editFormData.state || citiesDropdown.length === 0}>
              <MenuItem value="">Select City (Optional)</MenuItem>
              {citiesDropdown.map(city => <MenuItem key={city._id} value={city._id}>{city.name}</MenuItem>)}
            </Select>
          </FormControl>

          <TextField margin="dense" name="localAddress" label="Local Address" fullWidth variant="outlined" value={editFormData.localAddress || ""} onChange={handleEditFormChange} sx={{ mb: 2 }} />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} disabled={updating}>Cancel</Button>
          <Button onClick={handleUpdateSubmit} variant="contained" color="primary" disabled={updating}>
            {updating ? "Updating..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete Confirm Dialog ── */}
      <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this news?</DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleting}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={deleting}>
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyNews;

